import React from "react";
import { BarChart3, FileSpreadsheet, Lock, Settings2, Users } from "lucide-react";

import { Hero, FeaturesGrid, CTASection } from "../Components/sections";
import Seo from "../Components/seo/Seo";
import { products } from "../content/products";

function EbAccounting() {
  const product = products.find((p) => p.id === "accounting");

  return (
    <div>
      <Seo title="EasyBooks Accounting" description={product.description} />
      <Hero
        eyebrow="Product"
        title={product.name}
        subtitle={product.description}
        primaryCta={{ label: "Request a demo", to: "/Contact" }}
        secondaryCta={{ label: "See ERP", to: "/EasyBooks_ERP" }}
        imageSrc={product.heroSrc}
        imageAlt={product.name}
        highlights={product.highlights}
      />

      <section className="eb-section">
        <div className="eb-container">
          <div className="grid gap-8 lg:grid-cols-2">
            <div className="eb-card overflow-hidden">
              <img
                src={product.imageSrc}
                alt={`${product.name} screenshot`}
                className="h-[360px] w-full object-cover"
                loading="lazy"
                decoding="async"
              />
            </div>
            <div className="flex flex-col justify-center">
              <h2 className="eb-h2">Accounting built for day-to-day operations</h2>
              <p className="mt-4 eb-muted text-lg">
                EasyBooks Accounting helps you stay organized, reduce manual work, and keep a clear view of your
                financial position—without complex setup.
              </p>
              <ul className="mt-6 space-y-3 text-sm text-slate-700">
                <li className="flex gap-2">
                  <span className="mt-1 h-2 w-2 rounded-full bg-brand-700" />
                  Run on-premise or online
                </li>
                <li className="flex gap-2">
                  <span className="mt-1 h-2 w-2 rounded-full bg-brand-700" />
                  Manage multiple companies and files
                </li>
                <li className="flex gap-2">
                  <span className="mt-1 h-2 w-2 rounded-full bg-brand-700" />
                  Customizable to match your accounting workflows
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <FeaturesGrid
        eyebrow="Why EasyBooks Accounting"
        title="Everything you need to stay in control."
        subtitle="Designed for SMEs and institutions that want clarity, automation, and strong support."
        columns={3}
        features={[
          {
            title: "User-friendly",
            description: "A simple interface that doesn’t require prior accounting package experience.",
            icon: Users,
          },
          {
            title: "Budgeting & reporting",
            description: "Plan and monitor budgets with reporting that helps you stay on track.",
            icon: FileSpreadsheet,
          },
          {
            title: "Secure by design",
            description: "Role-based access and controls to keep your data protected.",
            icon: Lock,
          },
          {
            title: "Customizable",
            description: "Tailor workflows and features to fit your organization’s needs.",
            icon: Settings2,
          },
          {
            title: "Multi-company support",
            description: "Manage multiple organizations with separate data files.",
            icon: BarChart3,
          },
        ]}
      />

      <CTASection
        title="Want a quick walkthrough?"
        subtitle="Tell us your organization type and reporting needs  we’ll show you the best setup."
        primaryCta={{ label: "Contact us", to: "/Contact" }}
        secondaryCta={{ label: "Explore IMERIS", to: "/EasyBooks_IMERIS" }}
      />
    </div>
  );
}

export default EbAccounting;